import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { bffFetch, Headers } from './bff-fetch';

export class PoiContentSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetchPoi(context: ContextStore, poiIds: string[]) {
    if (context && poiIds) {
      return bffFetch(this.host, `poi/${poiIds}`, context, null, this.logger, this.forwardedHeaders);
    }
  }
}
